@if (!submitted) {
  <div style="padding: 12px; border: 1px dashed #3333ee">
    <p>
      <ng-content></ng-content>
    </p>
    <div [hidden]="featureName == ''">
      <div style="font-size: 1.1em; font-weight: bold">
        Would this feature be helpful?
      </div>
      <div style="margin-bottom: 10px">
        <input
          type="radio"
          name="helpful"
          value="Yes"
          [(ngModel)]="this.feedback.isHelpful"
        />
        Yes<br />
        <input
          type="radio"
          name="helpful"
          value="No"
          [(ngModel)]="this.feedback.isHelpful"
        />
        No<br />
        <input
          type="radio"
          name="helpful"
          value="I don't know"
          [(ngModel)]="this.feedback.isHelpful"
        />
        I don't know<br />
      </div>
    </div>
    <div
      [hidden]="featureName != ''"
      style="font-size: 1.1em; font-weight: bold"
    >
      What's your idea?
    </div>
    <div
      [hidden]="featureName == ''"
      style="font-size: 1.1em; font-weight: bold"
    >
      Share your thoughts about this feature:
    </div>
    <textarea
      cols="80"
      rows="6"
      [(ngModel)]="this.feedback.thoughts"
    ></textarea>
    <div>
      <input
        type="button"
        value="Submit"
        class="button_secondary button_var_2 button_right-spacing"
        (click)="btnSubmit_click()"
        (keydown.enter)="btnSubmit_click()"
      />
    </div>
  </div>
}
@if (submitted) {
  <div>Your response has been recorded. Thanks!</div>
}
